import { useMemo, useState, useCallback } from "react";
import { ModalContext } from "../contexts/ModalContext";

export default function ModalProvider({ children }: any) {
  const [state, setState] = useState({
    open: false,
    closeButton: true,
    children: null,
    title: "",
  });

  const open = useCallback((title: string, children: any) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      children,
      title,
    }));
  }, []);

  const close = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      open: false,
      children: null,
      title: "",
    }));
  }, []);

  const hideCloseButton = useCallback((buttonState: boolean) => {
    setState((prevState) => ({ ...prevState, closeButton: buttonState }));
  }, []);

  const value = useMemo(
    () => ({
      state,
      open,
      close,
      hideCloseButton,
    }),
    [state, open, close, hideCloseButton],
  );

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
}
